import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import axios, { API, setUser } from '../api';

const SIDEBAR_WIDTH = 264;

function Layout() {
  // Rafraîchit le profil (rôle, statut, permissions d'équipe) à chaque montage :
  // les changements de permissions faits par le propriétaire s'appliquent ainsi
  // sans devoir se reconnecter.
  const [, setRefreshed] = useState(false);
  useEffect(() => {
    (async () => {
      try {
        const { data } = await axios.get(`${API}/api/auth/me`);
        setUser(data);
        setRefreshed(true); // re-render → sidebar filtrée avec les perms à jour
      } catch (e) { /* interceptors gèrent 401/403 */ }
    })();
  }, []);

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh', bgcolor: 'background.default' }}>
      <Sidebar width={SIDEBAR_WIDTH} />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          minHeight: '100vh',
          width: { xs: '100%', md: `calc(100% - ${SIDEBAR_WIDTH}px)` },
          ml: { md: `${SIDEBAR_WIDTH}px` },
          px: { xs: 2, sm: 3, md: 4 },
          py: { xs: 2, md: 4 },
        }}
      >
        <Box sx={{ maxWidth: 1400, mx: 'auto' }}>
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
}

export default Layout;
